import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SmoothScroll } from "./SmoothScroll";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { FloatingDock } from "./FloatingDock";

export const PageShell = ({ children, testId }) => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return (
    <main data-testid={testId}>
      <SmoothScroll />
      <Header />
      {children}
      <Footer />
      <FloatingDock />
    </main>
  );
};
